<div class="customer-details-card p-20">
  <div class="row">
    <div class="col-lg-12">
      <app-card cardTitle="{{ 'info' | translate }}" [padding]="20">
        <ng-template #headerOptionsTemplate>
          <button mat-mini-fab color="primary" mat-dialog-close><i class="ti ti-x"></i></button>
        </ng-template>
        <div class="personal-details">
          <div class="row">
            @for (col of dataColumns; track col) {
            <div class="col-md-6">
              <p class="m-b-5 text-muted">
                {{ getdisplayedHeaders(col)}}
              </p>
              <div class="f-w-500" *ngIf="viewData">{{ viewData[col['fieldname']] != null ? viewData[col['fieldname']]
                :'----' }}</div>
            </div>
            }
            @empty {
            <div class="col-md-12">
              <p>{{'NoDatabyFilter' | translate}}</p>
            </div>
            }
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>